const actions = {
	SET_CURRENT_ENROLLMENT: "SET_CURRENT_ENROLLMENT",
	DELETE_CURRENT_ENROLLMENT: "DELETE_CURRENT_ENROLLMENT"
};

export default actions;
